export function HomeButtons(props) {
    return(
        <div className="bottom-half">
            <button className="button button-start" onClick={props.start}>
                <span className="button-text">
                    START
                </span>
            </button>
            <button 
                className="button button-settings"
                onClick={props.settings}>
                <img 
                    src={require("../media/settings.png")} 
                    alt="settings icon"
                    className="settings-icon"/>
            </button>
        </div>
    );
}